// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"styles_modalWrap__1cS_L","forControl":"styles_forControl__37YHG","default":"styles_default__2zV6h"};